import { markRaw } from 'vue'
import componentTypes from '@/constants/componentTypes'

import Alert from '@/components/modules/Alert.vue'
import Avatar from '@/components/modules/Avatar.vue'
import BiometricToggle from '@/components/app/settings/BiometricToggle.vue'
import Buttons from '@/components/modules/Buttons.vue'
import Calendar from '@/components/modules/Calendar.vue'
import Card from '@/components/modules/Card.vue'
import CenterLayout from '@/components/modules/CenterLayout.vue'
import Comments from '@/components/modules/Comments.vue'
import ContentMeta from '@/components/modules/ContentMeta.vue'
import CustomMap from '@/components/modules/CustomMap.vue'
import Detail from '@/components/modules/Detail.vue'
import Events from '@/components/modules/Events.vue'
import Form from '@/components/modules/Form.vue'
import FunnelForm from '@/components/modules/FunnelForm.vue'
import FunnelFormStudentSelector from '@/components/modules/FunnelFormStudentSelector.vue'
import Gallery from '@/components/modules/Gallery.vue'
import GalleryListItem from '@/components/modules/GalleryListItem.vue'
import GroupListItem from '@/components/modules/GroupListItem.vue'
import Heading from '@/components/modules/Heading.vue'
import Html from '@/components/modules/Html.vue'
import IconText from '@/components/modules/IconText.vue'
import Identification from '@/components/modules/Identification.vue'
import ImpersonationSelector from '@/components/modules/ImpersonationSelector.vue'
import LearningMoment from '@/components/modules/LearningMoment.vue'
import List from '@/components/modules/List.vue'
import ListItem from '@/components/modules/ListItem.vue'
import MockDataToggle from '@/components/app/settings/MockDataToggle.vue'
import NotificationHistory from '@/components/modules/NotificationHistory.vue'
import NotificationList from '@/components/modules/NotificationList.vue'
import NotificationSettings from '@/components/modules/NotificationSettings.vue'
import NotificationToggle from '@/components/modules/NotificationToggle.vue'
import NotificationsListItem from '@/components/modules/NotificationsListItem.vue'
import Pagination from '@/components/modules/Pagination.vue'
import Radio from '@/components/modules/Radio.vue'
import ScoreCard from '@/components/modules/ScoreCard.vue'
import SelectionList from '@/components/modules/SelectionList.vue'
import SelectionSearch from '@/components/modules/SelectionSearch.vue'
import SimpleListItem from '@/components/modules/SimpleListItem.vue'
import SocialLinks from '@/components/modules/SocialLinks.vue'
import SpaceListItem from '@/components/modules/SpaceListItem.vue'
import SparkListItem from '@/components/modules/SparkListItem.vue'
import Subscriptions from '@/components/modules/Subscriptions.vue'
import Switch from '@/components/modules/Switch.vue'
import Tabs from '@/components/modules/Tabs.vue'
import TourStep from '@/components/modules/TourStep.vue'

export default Object.freeze({
    [componentTypes.Alert]: markRaw(Alert),
    [componentTypes.Avatar]: markRaw(Avatar),
    [componentTypes.BiometricToggle]: markRaw(BiometricToggle),
    [componentTypes.Buttons]: markRaw(Buttons),
    [componentTypes.Calendar]: markRaw(Calendar),
    [componentTypes.Card]: markRaw(Card),
    [componentTypes.CenterLayout]: markRaw(CenterLayout),
    [componentTypes.Comments]: markRaw(Comments),
    [componentTypes.ContentMeta]: markRaw(ContentMeta),
    [componentTypes.CustomMap]: markRaw(CustomMap),
    [componentTypes.Detail]: markRaw(Detail),
    [componentTypes.Events]: markRaw(Events),
    [componentTypes.Form]: markRaw(Form),
    [componentTypes.FunnelFormStudentSelector]: markRaw(FunnelFormStudentSelector),
    [componentTypes.FunnelForm]: markRaw(FunnelForm),
    [componentTypes.GalleryListItem]: markRaw(GalleryListItem),
    [componentTypes.Gallery]: markRaw(Gallery),
    [componentTypes.GroupListItem]: markRaw(GroupListItem),
    [componentTypes.Heading]: markRaw(Heading),
    [componentTypes.Html]: markRaw(Html),
    [componentTypes.IconText]: markRaw(IconText),
    [componentTypes.Identification]: markRaw(Identification),
    [componentTypes.ImpersonationSelector]: markRaw(ImpersonationSelector),
    [componentTypes.LearningMoment]: markRaw(LearningMoment),
    [componentTypes.ListItem]: markRaw(ListItem),
    [componentTypes.List]: markRaw(List),
    [componentTypes.MockDataToggle]: markRaw(MockDataToggle),
    [componentTypes.NotificationHistory]: markRaw(NotificationHistory),
    [componentTypes.NotificationList]: markRaw(NotificationList),
    [componentTypes.NotificationSettings]: markRaw(NotificationSettings),
    [componentTypes.NotificationToggle]: markRaw(NotificationToggle),
    [componentTypes.NotificationsListItem]: markRaw(NotificationsListItem),
    [componentTypes.Pagination]: markRaw(Pagination),
    [componentTypes.Radio]: markRaw(Radio),
    [componentTypes.ScoreCard]: markRaw(ScoreCard),
    [componentTypes.SelectionList]: markRaw(SelectionList),
    [componentTypes.SelectionSearch]: markRaw(SelectionSearch),
    [componentTypes.SimpleListItem]: markRaw(SimpleListItem),
    [componentTypes.SocialLinks]: markRaw(SocialLinks),
    [componentTypes.SpaceListItem]: markRaw(SpaceListItem),
    [componentTypes.SparkListItem]: markRaw(SparkListItem),
    [componentTypes.Subscriptions]: markRaw(Subscriptions),
    [componentTypes.Switch]: markRaw(Switch),
    [componentTypes.Tabs]: markRaw(Tabs),
    [componentTypes.TourStep]: markRaw(TourStep),
})
